export var CaseType;
(function (CaseType) {
    /** For example: camelCase */
    CaseType[CaseType["camelCase"] = 0] = "camelCase";
    /** For example: PascalCase */
    CaseType[CaseType["pascalCase"] = 1] = "pascalCase";
    /** For example: snake_case */
    CaseType[CaseType["snakeCase"] = 2] = "snakeCase";
    /** For example: kebab-case */
    CaseType[CaseType["kebabCase"] = 3] = "kebabCase";
})(CaseType || (CaseType = {}));
//# sourceMappingURL=caseType.enum.js.map